import { EntityVm } from 'api/core/entity.vm';
import { IsString, IsNumber, IsOptional } from 'class-validator';

export class ReplenishmentThresholdVm extends EntityVm {
  @IsString()
  warehouseId: string;

  @IsString()
  locationId: string;

  @IsString()
  productId: string;

  @IsString()
  productName: string;

  @IsString()
  productSku: string;

  @IsNumber()
  min: number;

  @IsNumber()
  max: number;
}
